import React, {useContext, useState, useEffect} from 'react';
import {VerificationCenter_API} from "../VerificationCenterAPI";
import {useHttp} from "../../../hooks/http.hook";
import {AuthContext} from "../../../context/AuthContext";
import OrgPage from "../../../components/OrgPage";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import { useAPI } from '../../../hooks/useAPI'
import pencilSVG from '../../../components/Pages/TablePage/Table/Cells/LinkCell3/pencil.svg'
import NumberFormat from 'react-number-format';
import ApiSearchInput from '../../../components/Organisms/APISearchInput'
import Select, { components } from 'react-select'
import {generateRandomString} from '../../../utils/generateRandomString'
import moment from "moment";
import DatePicker from "react-date-picker";
import styled from "styled-components";

function rtrim ( str, charlist ) {  
    charlist = !charlist ? ' \s\xA0' : charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '\$1');
    var re = new RegExp('[' + charlist + ']+$', 'g');
    return str.replace(re, '');
}

const SelectCustomStyles = { 
	control: ()=>({
		border: 'none',
		background: 'aliceblue',
		width: '100%',
        // height: '50px',
        display: 'flex',
        position: 'relative',
	})
}

const DefaultSpecOptions = [
	{label: 'Флюорография', value: 'Флюорография'},
	{label: 'Маммография', value: 'Маммография'},
]
const chooseme =  (val,options) => {
	console.log('chooseme',val)
	return val;
	//return [{label: 'Выберите', value: 'a'},{label: 'Заберите', value: 'b'},]
}
const arr2options = (sx,mySpecOptions) => {
	let res = [];
	for (let i = 0; i < mySpecOptions.length; i++) {
		if ( sx && sx.includes(mySpecOptions[i].value)  ) 
		{ 
			res.push(mySpecOptions[i]);
		}
	}
	return res;
}


const StyledDateInput = styled.div`
  _ * {
    font-weight: normal;
  }

  label {
    font-weight: bold;
  }

  .react-date-picker__wrapper {
    border: 0 solid black;
  }

  .react-date-picker__inputGroup__input {
    outline: none;
    font-weight: normal;

    ::placeholder {
      color: black;
    }
  }
`;


function Doctors() {
    const {
        getDoctors, saveDoctor, getListOfStudyTypes
    } = VerificationCenter_API.doctor

	useEffect(async () => {
		await APIRequest(getListOfStudyTypes(), {query: ''})
				.then(response => {
				  if (response.body) {
					let opts = [];
					for (let i = 0; i < response.body?.data.length; i++) {
						let s = response.body?.data[i];
						opts.push({label: s, value: s},)
					}
					setSpecOptions(opts);
				  }
				})
	}, []); // Pass empty array to only run once on mount.

    const {token} = useContext(AuthContext)
	const { APIRequest } = useAPI()
    const [refresh, setRefresh] = useState(false)
	const [modalVisible, setModalVisible] = useState(false);
	const [id, setId] = useState(0);
	const [fio, setFio] = useState('');
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const [pass, setPass] = useState('');
	const [city, setCity] = useState('');
	const [address, setAddress] = useState('');
	const [dob, setDob] = useState('');
	const [specialization, setSpecialization] = useState([])
	const [specOptions, setSpecOptions] = useState(DefaultSpecOptions)

	const saveDoctorNow = async()=>{
		let specs = '';
		if (specialization) {
			for (let i = 0; i < specialization.length; i++) {
				specs += specialization[i].value + ',';
			}
		}
		specs = rtrim(specs,',');
		await APIRequest(saveDoctor(token.userId,id), {
			fio:fio,
			email:email,
			phone:phone,
			pass:pass,
			address:address,
			city:city,
			dob:dob,
			specialization: specs,
		})
			.then(async(response) => {
			  if (response.body) {
				  alert(response.body?.message);
				  if (response.body?.message=='ok') {
					  //setModalVisible(false);
					  //setRefresh(true)
					  window.location.reload(false);
				  }
			  }
			})
	}

    return (<>
			{ modalVisible ? 
					<div className="fade-in-fwd modal" onClick={()=>{setModalVisible(false)}}
						style={{left: 90, zIndex: 101}} >
						<div className="layer"
							style={{position: 'absolute', width: '100%', height: '100%'}}></div>
						<div className="formModal" ><div className="auth__form" onClick={(e)=>{e.stopPropagation();}}>
							<div className="closeButton" onClick={()=>{setModalVisible(false)}}>
								<i className="fas fa-times" style={{color: 'rgb(128, 189, 255)'}}></i>
							</div>
							<div className="formModal__title">Редактирование доктора</div>
							<form className="auth__login-form auth__client__login-form" style={{maxHeight: 700}}>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="fio">Имя <span>*</span></label>
									<input id="fio" className="form-input live-Search__input" 
										value={fio} onChange={(event)=>{setFio(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="email">Емайл</label>
									<input id="email" className="form-input live-Search__input" 
										value={email} onChange={(event)=>{setEmail(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="city">Город</label>
									<input id="city" className="form-input live-Search__input" 
										value={city} onChange={(event)=>{setCity(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="address">Адрес</label>
									<input id="address" className="form-input live-Search__input" 
										value={address} onChange={(event)=>{setAddress(event.target.value)}}/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="dob">Дата рождения</label>
									<StyledDateInput><DatePicker id="dob" 
										className="form-input live-Search__input" style={{border: 0}}
										value={dob?moment(dob, "YYYY-MM-DD").format():''} 
										format="d.M.y" disableCalendar
										yearPlaceholder={"гггг"}
										dayPlaceholder={"дд"}
										monthPlaceholder={"мм"}
										onChange={(date)=>{
											setDob( date?moment(date, "YYYY-MM-DD").format():'')
										}}/></StyledDateInput>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="email">Телефон <span>*</span></label>
									<NumberFormat
										id="phone" className="form-input live-Search__input" 
											value={phone} onChange={(event)=>{setPhone(event.target.value)}}
											format='+7(###)###-##-##'
											allowEmptyFormatting={true}
											mask={'_'}
									/>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="qq">Специализация <span>*</span></label>
									<div><Select onChange={(ev)=>{
											console.log('choosing by select',ev)
											setSpecialization(ev)
										}}  id="qq"
										options={specOptions} isMulti={true} delimiter={','}
										value={chooseme(specialization,specOptions)}
										styles={SelectCustomStyles}/></div>
								</div></div>
								<div className="live-Search"><div className="form__option ">
									<label htmlFor="pass">Пароль (оставьте пустым если не хотите менять)</label>
									<input id="pass" className="form-input live-Search__input" disabled={true}
										value={pass} onChange={(event)=>{setPass(event.target.value)}}/>
									<span
									style={{
										cursor: 'pointer',
										width: '100%',
										display: 'flex',
										justifyContent: 'center' 
									}}
									onClick={_ => setPass(generateRandomString(10))}>
									Сгенерировать новый  пароль</span>
								</div></div>
								<div className="form-buttons"><button className="sign-in__button" onClick={(e)=>{
									e.preventDefault();
									saveDoctorNow()
								}}>Сохранить</button></div>
							</form>
						</div></div>
					</div>
				: undefined}
        <OrgPage
            url={`${process.env.REACT_APP_BASE_URL}` + getDoctors(token.userId).api}
            refresh={refresh}
            exportTemplateButtons={{export: false, registry: false,
				create:'Добавить доктора',onCreate:()=>{
					setId(0)
					setFio('')
					setEmail('')
					setPhone('')
					setPass('')
					setCity('')
					setAddress('')
					setDob('')
					setSpecialization(arr2options(['Флюорография'], specOptions))
					setModalVisible(true)
				}}}
            filterBarButtons={{downloadTemplate: {show: false,}}}
            filterFieldsConf={{
                fio: true,
                verCenter: true,
                city: true,
                specialization: true,
                doctorStatus: true
            }}
            breadCrumbsItems={[
                {title: 'Доктор'},
                {title: 'Список докторов', actual: true},
            ]}

            firstRow={[
                {title: 'ФИО', id: 'fio'},
                {title: 'Город'},
                {title: 'Специализация'},
                {title: 'Рейтинг', id: 'rating'},
                {title: 'Статус'},
                {title: ''},
            ]}

            haveToShow={[
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.fio}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.city}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.specialization ? props.all.specialization.join(', '): ""}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.rating}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.status}/>}},
				{type: 'wrapperCell', typeData: {cell: props =>			<div className="cellWrapper"><div className="row__cell">
								<div style={{height:25,width:25,cursor:'pointer'}} onClick={()=>{
									console.log('spec=',props.all.specialization)
									setId(props.all.id)
									setFio(props.all.fio)
									setEmail(props.all.email)
									setPhone(props.all.phone)
									setPass('')
									setCity(props.all.city)
									setAddress(props.all.address)
									setDob(props.all.dob)
									setSpecialization(arr2options(props.all.specialization, specOptions))
									setModalVisible(true)
								}}>
									<img src={pencilSVG} alt="open"/>
								</div>
							</div></div>
				}},
            ]}
        />
		</>

    );
}

export default Doctors;